const { VUE_APP_NAME, VUE_APP_API, VUE_APP_FILE_API, VUE_APP_BIOMETRICS_URL } =
  process.env;

export {
  VUE_APP_API as apiBaseUrl,
  VUE_APP_NAME as appName,
  VUE_APP_FILE_API as tempUrl,
  VUE_APP_BIOMETRICS_URL as biometricsLink,
};
